import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, tap } from 'rxjs/operators';
import { AccountService } from './services/account/account.service';
import { User } from './models/user';
import { LocalStorageService } from 'angular-2-local-storage';
import { StateService } from './services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Organization } from './models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public disableMenu = true;
  public disableFooter = true;
  public isCollapsed = false;

  public currentUser?: User;
  public Breadcrumbs = this.stateService.Breadcrumbs$.value;
  public isGrooming = false;
  public isOnlineVeterinary = false;

  private destroyed$ = new Subject();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private accountService: AccountService,
    private localStorage: LocalStorageService,
    private stateService: StateService,
    private _changeDetectorRef: ChangeDetectorRef,

  ) {
    this.currentUser = this.localStorage.get('user');
    if (this.currentUser) {
      this.currentUser.isAdmin = this.currentUser.role === 'org_admin';
    }
    this.isGrooming = this.localStorage.get('is-grooming');
    this.isOnlineVeterinary = this.localStorage.get('isOnlineVeterinary');
  }

  ngOnInit(): void {
    this.routeEventsSubs();
    this.subsCurrentPageName();
  }

  private subsCurrentPageName(): void {
    this.stateService.Breadcrumbs$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((res) => {
      this.Breadcrumbs = res;
      this._changeDetectorRef.detectChanges();
    });
  }
  
  private routeEventsSubs(): void {
    this.router.events
        .pipe(
          filter((event: any) => event instanceof NavigationEnd),
          tap((event: NavigationEnd) => {
            // const { url, urlAfterRedirects } = event;
            const routeData: any = this.route.firstChild?.snapshot.data;
            this.disableMenu = routeData.disableMenu;
            this.disableFooter = routeData.disableFooter;
            if (window.innerWidth <= 768) {
              this.isCollapsed = true;
            }
          }),
          map((navigation: NavigationEnd) => navigation.url === '/'),
        )
        .subscribe();
  }

  public exit(): void {
    this.accountService.logout();
  }
}
